import { render, staticRenderFns } from "./CatSVG.vue?vue&type=template&id=22dcf576&scoped=true&"
import script from "./CatSVG.vue?vue&type=script&lang=js&"
export * from "./CatSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dcf576",
  null
  
)

export default component.exports